const CoreValueGraph = ({ data }) => {
    return (
        <div className="w-full flex flex-col">
            <div className="flex h-80 mb-6 flex-col overflow-scroll gap-10">
                {data.map((item) =>
                    <ChildItem text={item.text} width={item.value > 0 ? item.value > 1 ? item.value - 2 + "%" : item.value + "%" : "0%"} />
                )}
            </div>
            <AxisLine />
        </div>
    )
}

const ChildItem = ({ text, width }) => {
    return (
        <div className="w-full h-[9.9px] gap-5" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
            <div className="w-[25%] "
                style={{ color: "#828282", fontSize: "14px" }}
            >{text}</div>
            <div className="w-[70%] h-full border-r overflow-hidden" >
                <div
                    className="h-full"
                    style={{
                        width: String(width),
                        backgroundColor: "#7c63a4"
                    }}
                />
            </div>
        </div>
    )
}

const AxisLine = () => <div className="w-full mt-4 flex justify-between gap-5 ">
    <div className="w-[25%]"></div>
    <div className="flex w-[70%] flex-col">
        <div className="w-[100%] flex border border-r" />
        <div className="w-[100%] flex justify-between gap-[5%] border-t border-r">
            <div className="text-xs">0</div>
            <div className="text-xs">10</div>
            <div className="text-xs">20</div>
            <div className="text-xs">30</div>
            <div className="text-xs">40</div>
            <div className="text-xs">50</div>
            <div className="text-xs">60</div>
            <div className="text-xs">70</div>
            <div className="text-xs">80</div>
            <div className="text-xs">90</div>
            <div className="text-xs">100</div>
        </div>
    </div>
</div>

export default CoreValueGraph